import { api } from './index'

export type SherlockSsoTokenResponse = {
  token: string
}

export const sherlockSsoApi = api.injectEndpoints({
  endpoints: builder => ({
    createSherlockSsoToken: builder.mutation<SherlockSsoTokenResponse, void>({
      query: () => ({
        url: 'sherlock/sso_token',
        method: 'POST',
      }),
    }),
  }),
  overrideExisting: false,
})

export const { useCreateSherlockSsoTokenMutation } = sherlockSsoApi
